export default "<div class=\"banner\">\n    <span>{{ adminUsername | titlecase }} · You are logged in as an administrator</span>\n</div>\n"